module.exports = __webpack_public_path__ + "static/media/5.6748a007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cats/5.jpg
// module id = 210
// module chunks = 0